















































































































































































import Vue from 'vue'
import Component from 'vue-class-component'
import Accordion from './Accordion.vue'
import Icon from './Icon.vue'
import Checkbox from './inputsV2/Checkbox.vue'
import ScrollView from './ScrollView.vue'
import { ISelectItem } from '@/interfaces/Select'
import { IAccordionSelectItem } from '@/interfaces'
import InputV2 from '@/components/inputsV2/InputV2.vue'
// @ts-ignore
import ClickOutside from 'vue-click-outside'

@Component({
  directives: {
    ClickOutside
  },
  props: {
    items: {
      type: Array,
      default: []
    },
    error: {
      type: Boolean,
      default: false
    },
    selected: {
      type: [String, Number, Boolean]
    },
    defaultOpened: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: String,
    extraButton: Object,
    emptyText: {
      type: String,
      default: 'Empty'
    }
  },
  components: {
    InputV2,
    ScrollView,
    Accordion,
    Checkbox,
    Icon
  }
})
export default class AccordionSelect extends Vue {
  isOpened: boolean = false
  closeListLocale: Function = () => {
  }
  extraCheckboxesModels: Array<any> = []
  visibleExtraBlock: string = ''
  inputValue: string = ''

  get displayItems () {
    const items = JSON.parse(JSON.stringify(this.$props.items))
    return items.filter((item: IAccordionSelectItem) => {
      if (item.nested && item.nested.items) {
        item.nested.items = item.nested.items.filter((nitem: IAccordionSelectItem) => {
          if (nitem.items) {
            nitem.items = nitem.items.filter((subItem: any) => {
              return subItem.content.includes(this.inputValue)
            })
            return nitem.items.length > 0
          } else {
            return false
          }
        })
        return item.nested.items.length > 0
      }
      const items: any = item.items
      const filterdItems = items.filter((subItem: any) => {
        return subItem.content.includes(this.inputValue)
      })
      item.items = filterdItems
      return filterdItems.length > 0
    })
  }

  get selectedItemContent () {
    let selected
    for (let i = 0; i < this.$props.items.length; i++) {
      const item = this.$props.items[i]
      if (item.nested) {
        for (let k = 0; k < item.nested.items.length; k++) {
          const stepItems = item.nested.items[k].items
          for (let j = 0; j < stepItems.length; j++) {
            if (stepItems[j].value === this.$props.selected) {
              selected = stepItems[j]
              break
            }
          }
          if (selected) {
            break
          }
        }
      } else {
        const stepItems = item.items
        for (let j = 0; j < stepItems.length; j++) {
          if (stepItems[j].value === this.$props.selected) {
            selected = stepItems[j]
            break
          }
        }
      }

      if (selected) {
        break
      }
    }
    if (selected) {
      return selected.content
    }
    if (this.$props.placeholder) {
      return this.$props.placeholder
    }
    throw new Error('Can\'t find selected item')
  }

  openList () {
    if (!this.$props.disabled) {
      this.inputValue = ''
      this.isOpened = true
      // @ts-ignore
      this.$refs.inputField.$el.querySelector('input').focus()
    }
  }

  closeList () {
    this.isOpened = false
    this.visibleExtraBlock = ''
  }

  emitSelect (sitem: any, item: any) {
    if (!item.disabledItems || !item.disabledItems.includes(sitem.value)) {
      if (!sitem.extraCheckboxesList) {
        if (!this.$props.disabled) {
          this.inputValue = ''
          this.$emit('select', sitem)
        }
        this.closeList()
      } else {
        this.visibleExtraBlock = sitem.key
      }
    }
  }

  emitExtraCheckboxes (index: number, sindex: number) {
    const models = this.extraCheckboxesModels.filter((model: any) => {
      return model.index === index && model.sIndex === sindex
    })
    this.$emit('select', {
      ...models[0].sitem,
      checked: models.map((model: any) => {
        const checked: string[] = []
        Object.keys(model.value).forEach((key: string) => {
          if (model.value[key]) {
            checked.push(key)
          }
        })
        return checked
      })
    })
    this.closeList()
  }

  clearExtraCheckboxes (index: number, sindex: number) {
    const models = this.extraCheckboxesModels.filter((model: any) => {
      return model.index === index && model.sIndex === sindex
    })
    models.forEach((model: any) => (
      model.value = {}
    ))
    this.$forceUpdate()
  }

  isSelectedItem (sitem: ISelectItem) {
    return sitem.value === this.$props.selected
  }

  handleInput () {

  }

  mounted () {
    this.closeListLocale = this.closeList.bind(this)
    // this.$eventBus.$on('body:click', this.closeListLocale)
    // this.$eventBus.$on('Select:close', this.closeListLocale)
    // this.$eventBus.$on('AccordionSelect:close', this.closeListLocale)
    for (let i = 0; i < this.$props.items.length; i++) {
      const item = this.$props.items[i]
      const stepItems = item.items || []
      for (let j = 0; j < stepItems.length; j++) {
        const sitem = stepItems[j]
        if (sitem.extraCheckboxesList) {
          sitem.extraCheckboxesList.forEach((extraCheckboxes: any, cIndex: number) => (
            this.extraCheckboxesModels.push({
              item,
              index: i,
              cIndex,
              sitem,
              sIndex: j,
              value: {}
            })
          ))
        }
      }
    }
  }

  toggleExtraCheckbox (index: number, sindex: number, csitem: any, cindex: number, event: any) {
    const model = this.extraCheckboxesModels.find((model: any) => {
      return model.index === index && model.sIndex === sindex && model.cIndex === cindex
    })
    model.value[csitem.value] = event.target.checked
    this.$forceUpdate()
  }

  isAllExtraCheckboxesChecked (index: number, sindex: number, length: number, cindex: number) {
    const model = this.extraCheckboxesModels.find((model: any) => {
      return model.index === index && model.sIndex === sindex && model.cIndex === cindex
    })
    return Object.values(model.value).filter(Boolean).length === length
  }

  toggleAllExtraCheckboxes (index: number, sindex: number, list: any[], cindex: number, event: any) {
    const model = this.extraCheckboxesModels.find((model: any) => {
      return model.index === index && model.sIndex === sindex && model.cIndex === cindex
    })
    list.forEach((csitem: any) => {
      model.value[csitem.value] = event.target.checked
    })
    this.$forceUpdate()
  }

  isExtraCheckboxChecked (index: number, sindex: number, csitem: any, cindex: number, event: any) {
    const model = this.extraCheckboxesModels.find((model: any) => {
      return model.index === index && model.sIndex === sindex && model.cIndex === cindex
    })
    return model.value[csitem.value]
  }

  beforeDestroy () {
    // this.$eventBus.$off('body:click', this.closeListLocale)
    // this.$eventBus.$off('Select:close', this.closeListLocale)
    // this.$eventBus.$off('AccordionSelect:close', this.closeListLocale)
  }
}
